// Curated, aesthetically-strong photo pools for galleries and sub-package cards.
// Replaces random LoremFlickr keywords with hand-picked, relevant travel imagery
// (water bodies, architecture, monuments, luxury resorts, mountains, etc.).

const u = (id) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=800&auto=format&fit=crop`;
const px = (path) => `https://images.pexels.com/photos/${path}?auto=compress&cs=tinysrgb&w=800`;

export const POOLS = {
  coast: [
    u("1617532770043-3c7d49fe43d4"),
    u("1571274492344-748927a9549d"),
    u("1505142468610-359e7d316be0"),
    u("1524946274118-e7680e33ccc5"),
  ],
  architecture: [
    u("1605096048662-5ab61695a122"),
    u("1616036902568-fa623d8f0c0a"),
    u("1467269204594-9661b134dd2b"),
  ],
  sculpture: [
    u("1669801721766-b4dd8be33f4e"),
    px("18287214/pexels-photo-18287214.jpeg"),
    px("1565777/pexels-photo-1565777.jpeg"),
  ],
  hotel: [
    u("1733776718890-35988bbdf974"),
    u("1733776722031-c81dd9055e1b"),
    u("1733776724083-f8ec367f04a9"),
  ],
  beach: [
    u("1608340173100-5e36d2a76e91"),
    u("1620244919980-2e2cbb6fe728"),
    u("1683951443218-850f929b65e4"),
    u("1620244920004-f62535c304c4"),
  ],
  mountain: [
    u("1604223190546-a43e4c7f29d7"),
    u("1611080402167-ed75bae6df32"),
    u("1543359278-18e6c95a483c"),
    u("1575591316742-720c3693386d"),
  ],
  yoga: [
    px("5928334/pexels-photo-5928334.jpeg"),
    px("32658879/pexels-photo-32658879.jpeg"),
    u("1654000711330-caa1e07f60bb"),
    u("1533012562945-b003ce1d3269"),
    u("1646166468261-b18339c92fda"),
    u("1608405059861-b21a68ae76a2"),
  ],
  spa: [
    u("1532926381893-7542290edf1d"),
    u("1488345979593-09db0f85545f"),
    u("1610289982320-3891f7c9fd6d"),
    u("1732162933717-e87940716e10"),
  ],
  meditation: [
    u("1444312645910-ffa973656eba"),
    u("1600618528240-fb9fc964b853"),
    u("1604938814491-c696899ec59b"),
    u("1536623975707-c4b3b2af565d"),
  ],
  food: [
    u("1748540459503-19efc015143b"),
    u("1667473775795-41f69ae72c44"),
    u("1653611540493-b3a896319fbf"),
    u("1633760040841-1f708ce95c56"),
  ],
  yacht: [
    u("1562281302-809108fd533c"),
    px("32762717/pexels-photo-32762717.jpeg"),
    px("37372235/pexels-photo-37372235.jpeg"),
    u("1593351415075-3bac9f45c877"),
    u("1535024966840-e7424dc2635b"),
  ],
  sunset: [
    u("1648706903501-8b74096438df"),
    px("5605770/pexels-photo-5605770.jpeg"),
    u("1564224478612-9dedb7387a66"),
    px("19984985/pexels-photo-19984985.jpeg"),
  ],
  hiking: [
    u("1562593028-1fe2d15bde36"),
    u("1616494268339-f49a1c4ac8f8"),
  ],
  forest: [
    u("1595104615356-cbe9c4364513"),
    u("1440581572325-0bea30075d9d"),
    u("1687357282977-52f8b1dd2730"),
  ],
  nightlife: [
    u("1566417713940-fe7c737a9ef2"),
    u("1607185654436-3bd5d7a897ac"),
    u("1609992185485-d7391e0e3094"),
    u("1691364069600-55ad1660409e"),
  ],
  rooftop: [
    px("11262197/pexels-photo-11262197.jpeg"),
    px("19791632/pexels-photo-19791632.jpeg"),
    u("1768913573689-fa59c3c061cc"),
    u("1691364069600-55ad1660409e"),
  ],
  vineyard: [
    u("1767449189198-aad18c365ac0"),
    u("1775136879038-ee04b7ac6ab6"),
    u("1762362611583-8151f0a2c112"),
  ],
  snow: [
    u("1611572757951-6b8e7f068942"),
    u("1629730441758-e9b5cb99550d"),
    u("1612450639537-d44bc045efc7"),
  ],
  river: [
    u("1761158004206-8dac0bede305"),
    u("1589131252278-03cf36bc7b52"),
    u("1663649360617-77d6b7bb7797"),
    u("1772029573062-8cb0e22a7369"),
  ],
};

// Map every gallery/sub-package theme keyword onto a canonical pool.
const THEME_MAP = {
  // travel
  city: "architecture", island: "coast", food: "food", architecture: "architecture",
  sailing: "yacht", trail: "hiking", landmark: "sculpture", scenic: "mountain",
  ruins: "sculpture", train: "mountain", hiking: "hiking", family: "beach",
  luxury: "hotel", sunset: "sunset", vineyard: "vineyard", beach: "beach",
  mountain: "mountain", village: "architecture", market: "food", panorama: "mountain",
  coast: "coast", landscape: "mountain", wildlife: "forest", nature: "forest",
  // yoga
  yoga: "yoga", meditation: "meditation", spa: "spa", wellness: "spa", temple: "architecture",
  // wellness
  wine: "vineyard", boat: "yacht", pool: "hotel", rooftop: "rooftop", yacht: "yacht",
  nightlife: "nightlife", snorkeling: "coast", cocktail: "nightlife", springs: "spa",
  // adventure
  summit: "snow", climbing: "mountain", glacier: "snow", kayak: "river", sunrise: "sunset",
  snow: "snow", biking: "mountain", canyon: "river", paragliding: "mountain",
  river: "river", cave: "mountain", volcano: "mountain", snowing: "snow",
};

export const poolFor = (theme) => THEME_MAP[theme] || "coast";

export const photoFromPool = (theme, idx) => {
  const pool = POOLS[poolFor(theme)] || POOLS.coast;
  return pool[((idx % pool.length) + pool.length) % pool.length];
};
